module.exports = "img/45.1d944c.webp";